import { gql } from '@apollo/client';

export default gql`
  query GetAcademyCourseInvoice($courseId: String!, $invoiceId: String!) {
    invoice(courseId: $courseId, invoiceId: $invoiceId)
      @rest(
        type: "CourseInvoice"
        path: "academy/courses/{args.courseId}/invoices/{args.invoiceId}"
      ) {
      _id
      course
      coursePeriodDateEnd
      coursePeriodDateInit
      paid
      totalDebt
      lines {
        _id
        duration
        assignments
        assignmentAnswers
        group
        invoice
        practiceSessions
        createdAt
        updatedAt
        startDate
        endDate
        student {
          _id
          email
          name
        }
      }
    }
  }
`;
